<template>
    <div class="suppliers-update-modal">
        <ModalContainer :title="$t('suppliers.edit_supplier')" identifier="suppliers-update-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_loading_original || is_saving">
                <FormInputText v-model="$v.supplier.name.$model" identifier="name" :label="$t('suppliers.name')"
                               :disabled="is_loading_original || is_saving" :has-error="$v.supplier.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.supplier.name.required">
                            {{$t('validation.x_is_required',{x: $t('suppliers.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <FormInputText v-model="$v.supplier.phone.$model" identifier="phone" :label="$t('suppliers.phone')"
                               :disabled="is_loading_original|| is_saving" :has-error="$v.supplier.phone.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.supplier.phone.required">
                            {{$t('validation.x_is_required',{x: $t('suppliers.phone')})}}
                        </p>
                    </template>
                </FormInputText>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
    import _ from 'lodash';
    import ModalContainer from "../modal/ModalContainer";
    import Form from "../form/Form";
    import FormInputText from "../form/FormInputText";
    import FormGroupTwo from "../form/FormGroupTwo";
    import FormInputSelect from "../form/FormInputSelect";
    import {required, email} from 'vuelidate/lib/validators'
    import Button from "../Button";
    import FormInputPassword from "@/components/form/FormInputPassword";

    export default {
        name: "SuppliersUpdateModal",
        components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
        props: {
            supplier_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                original: null,
                supplier: {
                    name: null,
                    phone: null,
                },
                is_saving: false,
                is_loading_original: false,
            }
        },
        validations: {
            supplier: {
                name: {required},
                phone: {required},
            }
        },
        methods: {
            close(status) {
                this.$modal.hide('suppliers-update-modal', status);
            },
            save() {
                this.$v.supplier.$touch();
                if (this.$v.supplier.$anyError || this.is_saving)
                    return;

                this.is_saving = true;

                let payload = {}

                if (this.original.attributes.name !== this.$v.supplier.name.$model)
                    payload.name = this.$v.supplier.name.$model;

                if (this.original.attributes.phone !== this.$v.supplier.phone.$model)
                    payload.phone = this.$v.supplier.phone.$model;

                this.$axios.patch(`suppliers/${this.supplier_id}`, payload).then(({data}) => {
                    this.$notify({
                        text: this.$t('suppliers.success_updated'),
                        type: 'success',
                    });

                    this.is_saving = false;
                    this.close(true);
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('suppliers.error_update')),
                        type: 'error',
                    });
                });
            },
            populate() {
                if (!this.original || !this.supplier)
                    return;

                this.$v.supplier.name.$model = this.original.attributes.name;
                this.$v.supplier.phone.$model = this.original.attributes.phone;
            },
            async retrieveOriginalSupplier() {
                this.is_loading_original = true;

                await this.$axios.get(`suppliers/${this.supplier_id}`)
                    .then(({data}) => {
                        this.original = data.data;
                        this.is_loading_original = false;
                    })
                    .catch(e => {
                        this.is_loading_original = false;

                        this.$notify({
                            title: this.$t('error'),
                            text: this.$larerror(e.response.data, this.$t('suppliers.error_retrieve')),
                            type: 'error',
                        });
                    });
            },
        },
        async mounted() {
            await this.retrieveOriginalSupplier();
            this.populate();
        }
    }
</script>
